import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="relative flex min-h-[80svh] items-center justify-center overflow-hidden px-5 pt-24 text-center">
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-72 w-72 -translate-x-1/2 rounded-full bg-gold/10 blur-3xl" />
      <div className="relative">
        <p className="font-heading text-[22vw] font-black leading-none tracking-tighter text-gold/20 md:text-[12rem]">404</p>
        <h1 className="-mt-4 font-heading text-3xl font-bold tracking-tight md:text-4xl">This page took flight.</h1>
        <p className="mt-4 text-muted-foreground">The page you're looking for doesn't exist or has moved.</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-semibold text-navy-deep transition-transform hover:-translate-y-0.5">
          <ArrowLeft className="h-4 w-4" /> Back Home
        </Link>
      </div>
    </section>
  );
}
